/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-11-05 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志 (暂无)
 * @Do not edit And Do not edit
 */
import React from 'react'
import Top from '../../components/common/Top'
import './index.scss'
import styles from './index.module.css'
import { bodys, plate } from './mapareaList'
import { getWebsiteProject, getWebsiteHouse } from '../../utils/api'
import { message, Drawer, List, Avatar, Tag } from "antd";

class CityList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            project: [],
            visible: false
        }
    }
    componentDidMount() {
        this.clearOver()
        this.utilsApi()
    }
    getWebsiteHouse = async (list) => {
        this.setState({
            visible: true
        })
        let opts = {}
        opts.projectNo = list.projectNo
        opts.houseType = ''
        opts.pageIndex = '0'
        opts.pageSize = '10000'
        opts.projectName = list.projectName
        opts.towards = ''
        opts.label = ''
        opts.maxrent = ''
        opts.minrent = ''
        let data = await getWebsiteHouse(opts)
        if (data.code == 0) {
            this.setState({
                houseList: data.data.pageContent
            })
        } else {
            message.error(data.message)
        }
    }
    mapareaList(id) {
        const { nextZoom, type } = this.getTypeAndZoom()
        if (!id) {
            bodys.forEach(item => {
                this.createOverlays(item, nextZoom, type)
            })
        }
        if (id == 2490) {
            plate.forEach(item => {
                this.createOverlays(item, nextZoom, type, '小区')
            })
        }
        if (id == '小区') {
            const { project } = this.state
            console.log(project, 'projectprojectprojectproject')
            project.forEach(item => {
                this.createOverlays(item, nextZoom, type, '小区')
            })
        }

    }
    setMap() {
        const { project } = this.state
        let projects = []
        let myGeo
        AMap.plugin('AMap.Geocoder', function () {
            myGeo = new AMap.Geocoder()
        }, () => {
        })
        for (let i in project) {
            myGeo.getLocation(project[i].location, function (status, result) {
                console.log(result);
                console.log('第三层');
                if (status === 'complete' && result.geocodes.length) {
                    var lnglat = result.geocodes[0].location
                    project[i].latitude = lnglat.lat
                    project[i].longitude = lnglat.lng
                    project[i].name = project[i].projectName
                    project[i].count = project[i].kezuCount
                }
            }, '上海市')
        }
        console.log(project);
        this.setState({
            ...project
        })
    }
    utilsApi = async () => {
        const opts = {}
        opts.projectName = ''
        opts.district = ''
        opts.layout = ''
        opts.minRent = ''
        opts.maxRent = ''
        opts.houseType = ''
        opts.status = ''
        opts.pageIndex = '0'
        opts.pageSize = '100000'
        const list = await getWebsiteProject(opts)
        if (list.code == 0) {
            let num = 0
            let data = list.data.pageContent
            this.setState({
                project: data
            })
            this.setMap()
            for (let i in data) {
                num++
                for (let k in plate) {
                    if (data[i].layout === plate[k].name) {
                        plate[k].count++
                    }
                }
            }
            for (let i in bodys) {
                if (bodys[i].name == '奉贤') {
                    bodys[i].count = num
                }
            }

        } else {
            message.error(list.message)
        }
        this.init()
    }
    createOverlays = (data, zoom, type, id) => {
        let { name, count, sellPrice, longitude, latitude } = data
        if (id) {
            sellPrice = id
        }
        console.log(type);
        console.log('circle');
        if (type && type === 'circle') {
            this.createCircle([longitude, latitude], name, count, sellPrice, zoom)
        } else {
            if (longitude && latitude) {
                this.createRect([longitude, latitude], name, count, sellPrice, data)
            }
        }
    }
    createCircle(point, name, count, id, zoom) {
        var markerContent = `<div class="${styles.bubble}">
        <p class="${styles.name}">${name}</p>
        <p>${count}个小区</p> </div>`;
        var marker = new AMap.Marker({
            position: point,
            content: markerContent,
            offset: new AMap.Pixel(-40, -40)
        });
        marker.on('click', () => {
            this.map.setZoomAndCenter(zoom, point)
            this.map.clearMap();
            this.mapareaList(id != undefined ? id : 2490)
        })
        if (count != '0') {
            this.map.add(marker)  //渲染
        }
    }


    createRect(point, name, count, id, data) {
        var markerContent = `
        <div class="${styles.rect} ${count > 0 ? '' : styles.colorsY}">
            <span title="${name}" class="${styles.housename}">${name}</span>
            <span class="${styles.housenum}">${count > 0 ? '有可租' : '已满租'}</span>
            <i class="${styles.arrow} ${count > 0 ? '' : styles.colorsJ}"></i>
        </div>
        `;
        console.log(point);
        console.log('@@@@@@@@@@@@');
        var marker = new AMap.Marker({
            position: point,
            content: markerContent,
            offset: new AMap.Pixel(-50, -28)
        });
        marker.on('click', (e) => {
            // let types = e.changedTouches ? '1' : '2'
            // if (window.innerWidth <= 768) {
            //     const target = e.changedTouches ? e.changedTouches : e.pixel
            //     this.map.panBy((window.innerWidth) / 2 - (types == '1' ? target[0].clientX : target.x), (window.innerHeight - 360) / 2 - (types == '1' ? target[0].clientY : target.y))
            // } else {
            //     const target = e.pixel
            //     this.map.panBy((window.innerWidth + 500) / 2 - target.x, (window.innerHeight - 330) / 2 - target.y)
            // }
            this.props.history.push({ pathname: '/belows', query: data })
        })
        this.map.add(marker)  //渲染
    }
    getTypeAndZoom() {
        const zoom = this.map.getZoom()
        let nextZoom, type
        if (zoom >= 0 && zoom < 12) {
            // 区
            nextZoom = 13
            type = 'circle'
        } else if (zoom >= 12 && zoom < 14) {
            //镇
            nextZoom = 15
            type = 'circle'
        } else if (zoom >= 14 && zoom < 19) {
            // 小区
            type = 'rect'
        }

        return {
            nextZoom,
            type
        }
    }
    init = () => {
        const city_key = '上海市'
        const city_key_view = '上海市奉贤区'
        let map = new AMap.Map('container')

        this.map = map
        let _self = this
        let myGeo
        AMap.plugin('AMap.Geocoder', function () {
            myGeo = new AMap.Geocoder()
        }, () => {
        })
            myGeo.getLocation(city_key_view, function (status, result) {
                console.log('第一层');
                console.log(result);
                if (status === 'complete' && result.geocodes.length) {
                    var lnglat = result.geocodes[0].location
                    _self.map.setZoomAndCenter(10, [lnglat.lng, lnglat.lat]);
                    // // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
                    // _self.map.addControl(new AMap.Scale());
                    // // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
                    // _self.map.addControl(new AMap.ToolBar());
                    // // 在图面添加类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
                    // _self.map.addControl(new AMap.MapType());
                    _self.mapareaList('')
                } else {
                    message.error('获取点失败')
                }
            }, city_key)
        _self.map.on('movestart', function () {
            //  地图进行缩放的时候监听该函数,也就是点击的时候哈.缩放
            _self.setState({
                visible: false
            })
        });
        _self.map.on('zoomend', function () {
            // 地图进行缩放的时候监听该函数, 也就是点击的时候哈.缩放
            _self.map.clearMap();
            const zoom = _self.map.getZoom()
            if (zoom >= 0 && zoom < 12) {
                // 区
                _self.mapareaList('')
            } else if (zoom >= 12 && zoom < 14) {
                //镇
                _self.mapareaList(2490)
            } else if (zoom >= 14 && zoom < 19) {
                // 小区
                _self.mapareaList('小区')
            }
        });
    }
    clearOver() {
        for (let i in plate) {
            plate[i].count = 0
        }
        for (let i in bodys) {
            bodys[i].count = 0
        }
    }
    render() {
        const { visible, houseList } = this.state
        console.log(window.innerWidth)
        return (
            <div className={'map'} style={{ height: '100%', overflow: 'hidden' }}>
                <Top />
                <div style={{ height: '92%', width: '100%' }} id={'container'}></div>
                <Drawer
                    title="房源列表"
                    placement={window.innerWidth <= 768 ? 'bottom' : 'left'}
                    width={500}
                    height={window.innerWidth <= 768 && window.innerWidth > 500 ? 600 : window.innerWidth <= 500 ? 360 : null}
                    mask={false}
                    closable={false}
                    visible={visible}
                    id={'city'}
                    className={'ant-drawer-bodyMeta'}
                >
                    <List
                        itemLayout="horizontal"
                        dataSource={houseList}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<Avatar style={{ cursor: 'pointer' }} className={window.innerWidth < 500 ? 'imgmeta' : ''} src={item.img ? item.img.split(',')[0] : null} />}
                                    title={<h4 className={window.innerWidth < 500 ? 'htitleh' : ''}>{item.projectName}</h4>}
                                    description={
                                        <div id={'viewsRent'} style={{ position: 'relative' }}>
                                            <span className={window.innerWidth < 500 ? 'htitle' : 'titleSize'}>{item.area}㎡ | {item.houseNo}</span>
                                            <p className={window.innerWidth < 500 ? 'htitle price' : 'price'}><span className={window.innerWidth < 500 ? 'htitle rentview' : 'rentview'}>¥{item.rent}</span>/月</p>
                                            <p className={window.innerWidth < 500 ? 'htitle pos posheight' : 'pos'}>{item.localion}</p>
                                            <div className={window.innerWidth < 500 ? 'htitle ell' : 'ell'}>{item.roomLabel.split(',').map(items => {
                                                return (
                                                    <Tag className={window.innerWidth < 500 ? 'htitleblue' : ''} color="blue">{items}</Tag>
                                                )
                                            })}</div>
                                        </div>
                                    }
                                />
                            </List.Item>
                        )}
                    />
                </Drawer>
            </div>
        )
    }
}

export default CityList
